import { fileToBase64 } from "@/utils/file-upload";

export async function getUploadUrl(
  key: string,
  memberMeta?: {
    orgId: string;
    userId: string;
    token?: string;
  },
): Promise<string> {
  const url = memberMeta
    ? `/api/upload?key=${key}&orgId=${memberMeta.orgId}&userId=${memberMeta.userId}&token=${memberMeta.token}`
    : `/api/upload?key=${key}`;

  const response = await fetch(url, {
    method: "GET",
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || "Failed to get signed upload Url");
  }

  const data = await response.json();
  return data.url;
}
/**
 * Uploads a file to the S3 and returns the URL
 * @param organizationId The organization ID
 * @param key The key to store the file under
 * @param file the file to upload
 */
export async function uploadFile(
  organizationId: string,
  key: string,
  file: File,
) {
  let base64: string;

  if (file.type === "application/pdf") {
    // For PDFs, read as ArrayBuffer and convert to base64
    const arrayBuffer = await file.arrayBuffer();
    base64 = Buffer.from(arrayBuffer).toString("base64");
  } else {
    // For images, use the existing fileToBase64 function
    base64 = await fileToBase64(file);
  }

  const response = await fetch("/api/upload", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      organizationId,
      base64Image: base64,
      key,
      fileName: file.name,
      contentType: file.type,
    }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || "Failed to upload file");
  }
}
